import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useIntl } from "react-intl";

//Components
import { Grid, Typography, Container, Paper, Divider } from "@mui/material";
import { Button } from "@gpstrackit/react-controls"


//EndPoints
import { endpoints } from 'Core/defaultValues';

//Views
import DataView from 'Components/DataView';
import CreateEditDealer from '../.components/createEditDealer';

//Security
import { HasPermission } from "Core/security";

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    dealersCreateEditDealerOpenModal
} from 'Redux/actions';

const DealersMain = (props) => {
    const { messages } = useIntl();
    const tableRef = useRef();
    const dispatch = useDispatch();


    const createEditDealerOModal = useSelector(state => state.createEditDealerRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);

    const [columns, setColumns] = useState([

        {
            key: "id",
            title: messages['dealers_main_id'],
            width: 25,
            show: true,
            sort: true,
            locked: true,
            resize: true,
            export: true,
            functionString: 'return row?.id',
            code: "dealers_main_id",
            render: (item) => {
                return <span>{item?.id}</span>
            }
        },
        {
            key: "name",
            field: "name",
            title: messages['dealers_main_name'],
            width: 200,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            code: "dealers_main_name",
            render: (item) => {
                let name = item?.name
                if (name?.length >= 7) {
                    name = name?.substring(0, 40) + "...";
                }
                return (
                    <NavLink to={`/app/dealers/overview/${item?.id}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{name}</span>
                    </NavLink>
                )
            },
            export: true,
            functionString: 'return row?.name'
        },
        {
            key: "email",
            field: "email",
            title: messages['dealers_main_email'],
            width: 350,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            code: "dealers_main_email",
            render: (item) => {
                return <span>{item?.email}</span>
            },
            export: true,
            functionString: 'return row?.email'
        },
        {
            key: "username",
            field: "username",
            title: messages['dealers_main_username'],
            width: 250,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            code: "dealers_main_username",
            render: (item) => {
                return <span>{item?.username}</span>
            },
            export: true,
            functionString: 'return row?.username'
        },
        {
            key: "masterCompanyName",
            title: messages['dealers_main_master_company_name'],
            width: 200,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            code: "dealers_main_master_company_name",
            render: (item) => {
                let name = item?.masterCompany?.name || ""
                if (name?.length >= 7) {
                    name = name?.substring(0, 40) + "...";
                }
                return (
                    <NavLink to={`/app/accounts/overview/${item?.masterCompanyId}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{name}</span>
                    </NavLink>
                )
            },
            export: true,
            functionString: 'return row?.masterCompany?.name || ""'
        },
        {
            key: "crmId",
            title: messages['dealers_main_crm'],
            width: 200,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            code: "dealers_main_crm",
            render: (item) => {
                return <a
                    style={{ color: 'black' }}
                    href={`${endpoints.SALESFORCE_URL}lightning/r/Account/${item?.masterCompany?.crmId}/view`}
                    target="_blank"
                >
                    {item?.masterCompany?.crmId}
                </a>
            },
            export: true,
            functionString: 'return row?.masterCompany?.crmId'
        },
        {
            key: "brandId",
            field: "brand.title",
            title: messages['dealers_main_brand'],
            width: 200,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            code: "dealers_main_brand",
            render: (item) => {
                return <span>{item?.brand?.title}</span>
            },
            export: true,
            functionString: 'return row?.brand?.title'
        },
    ])
    const [searchFields, setSearchFields] = useState(["name", "email", "username", "company_name"]);
    const [total, setTotal] = useState(0);

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" gutterBottom component="div">
                            {messages['dealers_main_dealers']} ({total})
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className="main-view-buttons" style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            disabled={!HasPermission(user, "dea", "c")}
                            className="btn-dark-blue"
                            onClick={(e) => {
                                e.preventDefault();
                                dispatch(dealersCreateEditDealerOpenModal())
                            }}
                        >
                            {messages['dealers_main_add_dealer']}
                        </Button>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataView
                        ref={tableRef}
                        exportName="dealers"
                        dinamicQuery
                        name="pm-dealers"
                        entity="dealers"
                        graphqlFunction="searchDealers"
                        graphqlSort="DealerSortInput"
                        graphqlConditions="DealerSearchInput"
                        customQuery="id masterCompanyId masterCompany { name crmId }"
                        columns={columns}
                        hideAllInPagination
                        noFilters
                        asyncSelect
                        searchConditions={["name", "username", "email", "company_name"]}
                        searchOptionValue="id"
                        searchOptionLabel="name"
                        onChangeConditions={(tags, conditions, total, newColumns, rows, sort) => {
                            //current conditions
                            let currentConditions = {}
                            let currentTags = {}

                            if (!conditions && tags) {
                                currentConditions = tableRef?.current?.conditions;
                                currentTags = tags;
                            } else {
                                currentConditions = conditions || [];
                                currentTags = currentConditions?.filter((x) => x?.tags)[0]?.tags || [];
                                if (currentTags && currentTags.length > 0) tableRef?.current?.setTags(currentTags);
                            }

                            currentConditions = currentConditions?.filter((item) => item?.fields[0] !== 'id' && item?.fields[0] !== 'name');

                            let tagsById = currentTags.filter((item) => typeof item.id === "number");
                            if (tagsById?.length > 0) {
                                //New Items
                                let currentIds = tagsById.map((item) => (item.id));
                                if (currentIds.length > 0) {
                                    currentConditions.push({ fields: ["id"], terms: currentIds, exact: true, tags: currentTags, conditionOperator: "OR" });
                                }
                            }

                            let tagsByLabel = currentTags.filter((item) => typeof item.id === "string");

                            if (tagsByLabel.length > 0) {
                                let currentLabels = tagsByLabel.map((item) => (item.name))
                                if (currentLabels.length > 0) {
                                    currentConditions.push({ fields: searchFields, terms: currentLabels, exact: false, tags: currentTags, conditionOperator: "OR" })
                                }
                            }

                            if (!conditions && tags) tableRef?.current?.getData(null, null, null, currentConditions);
                            else tableRef?.current?.getData(null, rows, sort, currentConditions, newColumns);
                        }}
                        topheight={200}
                        onChangeTotal={(total) => setTotal(total)}
                        onFilters={() => { setOpenPanel(!openPanel) }}
                        noSplit
                        onChangeColumns={(items) => {
                            let currentColumns = items.map((item) => ({
                                ...item,
                                title: item.code ? messages[item.code] : item.title
                            }))
                            setColumns(currentColumns)
                        }}
                        tableButtons={["export", 'orderColumn']}
                        options={[
                            {
                                id: "dealers_main_edit",
                                label: messages['dealers_main_edit'],
                                single: true,
                                show: true,
                                disabled: !HasPermission(user, "dea", "u"),
                                action: (items) => {
                                    let currentItem = items.find(item => item.id);
                                    dispatch(dealersCreateEditDealerOpenModal(currentItem))
                                }
                            }
                        ]}
                        menuOptions={() => {
                            return [
                                messages['dealers_main_edit']
                            ]
                        }}
                        onClickMenu={(event, item) => {

                            if (event === messages['dealers_main_edit']) {
                                if (HasPermission(user, "dea", "u")) {
                                    dispatch(dealersCreateEditDealerOpenModal(item))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['dealers_main_edit'],
                                        5000,
                                    );
                                }
                            }

                        }}
                    />
                </Grid>
            </Paper>
            {
                createEditDealerOModal && <CreateEditDealer tableRef={tableRef} />
            }
        </Container>
    )
}
export default DealersMain;